import { createGlobalStyle } from 'styled-components';
import { theme } from '@/styles/theme';

export const GlobalStyles = createGlobalStyle<{ theme: typeof theme }>`
:root {
    --font-poppins: 'Poppins', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    /* iOS iframe viewport fix */
    width: 100%;
    -webkit-text-size-adjust: 100%;
    
    /* Mobile viewport height fix - use dynamic viewport on supported browsers */
    @supports (height: 100dvh) {
      height: 100dvh;
    }
  }

    button {
    font-family: Poppins, sans-serif;
  }

  input, textarea, select {
    font-family: Poppins, sans-serif;
  }

  /* Native select elements styling */
  select {
    background-color: ${({ theme }) => theme.colors.bgPrimary};
    border: 1px solid ${({ theme }) => theme.colors.grayLight};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    color: ${({ theme }) => theme.colors.text.inputColor};
    padding: ${({ theme }) => theme.spacing.sm};
    
    option {
      background-color: ${({ theme }) => theme.colors.bgPrimary};
      color: ${({ theme }) => theme.colors.text.inputColor};
    }
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    color: ${({ theme }) => theme.colors.dark};
    background-color: ${({ theme }) => theme.colors.bgSecondary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    /* iOS iframe viewport fix */
    width: 100%;
    min-width: 100%;
    -webkit-text-size-adjust: 100%;
    
    /* Mobile viewport height fix - use dynamic viewport on supported browsers */
    @supports (min-height: 100dvh) {
      min-height: 100dvh;
    }
  }

  #__next {
    height: 100%;
    min-height: 100vh;
    background-color: ${({ theme }) => theme.colors.bgSecondary};
    
    /* Mobile viewport height fix - use dynamic viewport on supported browsers */
    @supports (min-height: 100dvh) {
      min-height: 100dvh;
    }
  }
  
  #root {
    height: 100%;
    min-height: 100vh;
    background-color: ${({ theme }) => theme.colors.bgSecondary};
    /* iOS iframe viewport fix */
    width: 100%;
    min-width: 100%;
    
    /* Mobile viewport height fix - use dynamic viewport on supported browsers */
    @supports (min-height: 100dvh) {
      min-height: 100dvh;
    }
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.colors.secondary};
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.fontSize['3xl']};
  }

  h2 {
    font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.fontSize.xl};
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    line-height: ${({ theme }) => theme.typography.lineHeight.relaxed};
  }

  /* Links */
  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color ${({ theme }) => theme.transitions.fast};

    &:hover {
      color: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  /* Scrollbar - Hidden */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    display: none;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }

  /* Hide scrollbar for Firefox */
  * {
    scrollbar-width: none;
  }

  /* Hide scrollbar for IE and Edge */
  * {
    -ms-overflow-style: none;
  }

  /* Selection */
  ::selection {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }

  /* Focus styles */
  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  /* Utility classes */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;